import { render, staticRenderFns } from "./GeneratePriceLabelModal.vue?vue&type=template&id=082c5100"
import script from "./GeneratePriceLabelModal.vue?vue&type=script&lang=js"
export * from "./GeneratePriceLabelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports